// extracted by mini-css-extract-plugin
export var link = "link-zlv";
export var is_external = "is_external-ObY";